import { InfoCircleOutlined, SearchOutlined } from '@ant-design/icons'
import { t } from 'i18next'
import { useNavigate, useParams } from 'react-router-dom'
import  ResponsiveTabs, { TabItem } from '../../components/display/ResponsiveTab'
import { routePaths } from '../RootPage'
import {
  SearchReviewTabType,
  searchReviewPanelTypes,
  searchReviewTabs,
} from './SearchReviewDetailsPage'

const SearchReviewTabs = () => {
  const { panelType, tab, searchReviewId } = useParams()
  const navigate = useNavigate()

  const tabs: TabItem[] = [
    {
      key: searchReviewTabs.INFO,
      icon: <InfoCircleOutlined />,
      label: t('searchReviewDetailsPage.searchReviewTabs.tabInfo'),
    },
    {
      key: searchReviewTabs.QUERIES,
      icon: <SearchOutlined />,
      label: t('searchReviewDetailsPage.searchReviewTabs.tabQueries'),
    },
  ]

  const selectedTab = (tab || searchReviewTabs.INFO) as SearchReviewTabType

    const handleChange = (value: string) => {
    navigate(
      `${routePaths.SEARCH_REVIEW_DETAILS}/${searchReviewId}/${
        panelType || searchReviewPanelTypes.OVERVIEW
      }/${value}`
    )
  }

  return (
    <ResponsiveTabs
      tabs={tabs}
      selectedTab={selectedTab}
      onTabChange={handleChange}
    />
  )
}

export default SearchReviewTabs